import { Component, OnInit, ViewChild } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";

import {
  TableSchema,
  TableTypes,
  DataTableComponentBase,
  DataTableComponent,
  TableService,
  Filter,
} from "@kortobaa-front/k-ng-datatable";

import { AuthService } from "src/app/core/auth.service";
import { DataService } from "src/app/shared/services/data.service";
import { AssignDialogComponent } from "../../user-cases/assign-dialog/assign-dialog.component";
import { ConfirmDialogComponent } from "src/app/shared/components/confirm-dialog/confirm-dialog.component";
import { getHeadersWithToken } from "src/app/shared/helpers/getHeadersWithToken";
import { ServicesSlug, UserRoles } from "src/app/shared/models/interfaces";
import { environment } from "src/environments/environment";
import * as moment from "moment-timezone";
import { isIsoDate } from "src/app/shared/helpers/date.helper";
import { ActivatedRoute, Router } from "@angular/router";

enum RowActions {
  transferToLawyer = "transferToLawyer",
  transferToReconciliation = "transferToReconciliation",
  transferToSupervisor = "transferToSupervisor",
  caseEnding = "caseEnding",
}
@Component({
  selector: "app-lawyers-reports",
  templateUrl: "./lawyers-reports.component.html",
  styleUrls: ["./lawyers-reports.component.scss"],
})
export class LawyersReportsComponent
  extends DataTableComponentBase
  implements OnInit
{
  moduleName = "reports";
  url = "lawyers-reports";

  serviceSlug: ServicesSlug = ServicesSlug.INQUIRY_SERVICES;
  currentPageSize: number = 10; 
  servicesTabs = [
    {
      title: "الإستشارات المحالة للمحامين",
      type: "inquiry",
      count: 0,
      slug: ServicesSlug.INQUIRY_SERVICES,
    },
    {
      title: "القضايا المحالة للمحامين",
      type: "case",
      count: 0,
      slug: ServicesSlug.COURT_SERVICES,
    },
    {
      title: "الخدمات الكتابية المحالة للمحامين",
      type: "case",
      count: 0,
      slug: ServicesSlug.LEGAL_SERVICES,
    },
  ];

  filters: Filter = {
    where: {
      and: [
        {
          created_at: {
            gt: new Date(
              new Date().setDate(new Date().getDate() - 7)
            ).toISOString(),
          },
        },
        { created_at: { lt: new Date(Date.now()).toISOString() } },
      ],
    },
  };

  displayedColumns: TableSchema[] = [
    // {
    //   title: "case-code",
    //   id: "request_num",
    //   type: TableTypes.number,
    //   editable: false,
    //   notOnFilter: true,
    // },
    // {
    //   title: "case-type-name",
    //   id: "case_title",
    //   type: TableTypes.text,
    //   editable: false,
    //   notOnFilter: true,
    // },
    {
      title: "lawyerName",
      id: "username",
      type: TableTypes.text,
      editable: false,
      notOnFilter: true,
    },
    {
      title: "created-date-of-usercase",
      id: "request_date",
      type: TableTypes.text,
      editable: false,
      notOnFilter: false,
    },
    {
      title: "supervisor-acceptance-date",
      id: "supervisor_accept",
      type: TableTypes.text,
      editable: false,
      notOnFilter: false,
    },
    {
      title: "assigment-date",
      id: "assignment_date",
      type: TableTypes.text,
      editable: false,
      notOnFilter: false,
    },
    {
      title: "accept-assigment-date",
      id: "acceptance_date",
      type: TableTypes.text,
      editable: false,
      notOnFilter: false,
    },
    {
      title: "end-date",
      id: "enddate",
      type: TableTypes.text,
      editable: false,
      notOnFilter: false,
    },
  ];
  dataSource;
  isDataLoading = false;

  @ViewChild(DataTableComponent)
  private _dataTableComponent: DataTableComponent;

  constructor(
    public authService: AuthService,
    private _tableService: TableService,
    private _dataService: DataService,
    private _dialog: MatDialog,
    private _http: HttpClient,
    private _translate: TranslateService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router
  ) {
    super();
    this._tableService.tableUrl = "admin/lawyer-statistical-report";

    const caseColumns = [
      {
        title: "case-code",
        id: "request_num",
        type: TableTypes.text,
        editable: true,
      },
      {
        title: "case-type-name",
        id: "case_title",
        type: TableTypes.text,
        editable: true,
      },
    ];

    const inquiryColumns = [
      {
        title: "inquiry-code",
        id: "application_no",
        type: TableTypes.text,
        editable: true,
      },
      {
        title: "service_name",
        id: "case_title",
        type: TableTypes.text,
        editable: true,
      },
    ];

    this._activatedRoute.queryParams.subscribe((params) => {
      this.serviceSlug = params["serviceSlug"];

      if (
        this.serviceSlug === ServicesSlug.INQUIRY_SERVICES ||
        !this.serviceSlug
      ) {
        this.serviceSlug = ServicesSlug.INQUIRY_SERVICES;
        this.displayedColumns.splice(0, 0, ...inquiryColumns);
      } else {
        this.displayedColumns.splice(0, 0, ...caseColumns);
      }
    });
  }

  async ngOnInit() {
    await this.fetchServicesCounts();
  }

  async fetchServicesCounts(): Promise<void> {
    this._tableService.tableUrl = `admin/inquiry/lawyer-statistical-report`;
    try {
      const response: any = await this._tableService
        .getDataCount({})
        .toPromise();
      this.servicesTabs[0].count = response.count;
    } catch (error) {
      console.error("Error fetching service counts:", error);
    }

    this._tableService.tableUrl = `admin/lawyer-statistical-report`;
    try {
      const response: any = await this._tableService
        .getDataCount({ and: [{ service: ServicesSlug.COURT_SERVICES }] })
        .toPromise();
      this.servicesTabs[1].count = response.count;
    } catch (error) {
      console.error("Error fetching service counts:", error);
    }

    try {
      const response: any = await this._tableService
        .getDataCount({ and: [{ service: ServicesSlug.LEGAL_SERVICES }] })
        .toPromise();
      this.servicesTabs[2].count = response.count;
    } catch (error) {
      console.error("Error fetching service counts:", error);
    }
  }

  async getData(filters?: Filter) {
    if(filters?.limit) { 
      this.currentPageSize = filters.limit ; 
    }
    filters["where"] = this.filters.where;
    this.isDataLoading = true;

    if (this.serviceSlug !== ServicesSlug.INQUIRY_SERVICES) {
      if (
        !filters.where.and ||
        filters.where.and.length === 0 ||
        filters.where.and.every((obj) => Object.keys(obj).length === 0)
      ) {
        filters.where.and = [{ service: this.serviceSlug }];
      } else {
        // Remove any existing object containing a 'service' property
        filters.where.and = filters.where.and.filter(
          (obj) => !obj.hasOwnProperty("service")
        );
        // Add the new service object
        filters.where.and.unshift({ service: this.serviceSlug });
      }
    } else {
      filters.where.and = filters.where.and.filter(
        (obj) => !obj.hasOwnProperty("service")
      );
    }

    try {
      if (this.serviceSlug == ServicesSlug.INQUIRY_SERVICES) {
        this._tableService.tableUrl = "admin/inquiry/lawyer-statistical-report";
      } else {
        this._tableService.tableUrl = "admin/lawyer-statistical-report";
      }
      let data = await this._tableService.getData<any>(filters).toPromise();
      if (this.serviceSlug === ServicesSlug.INQUIRY_SERVICES) {
        this.dataSource = data.map((elem) => {
          for (let key in elem) {
            const isDate = isIsoDate(elem[key]);
            const isNullish = elem[key] == null;
            if (isNullish) elem[key] = "غير متاح";
            if (isDate) {
              moment.locale("ar");
              elem[key] = moment(new Date(elem[key])).format("LL");
            }
          }
          return {
            ...elem,
            case_title: elem.caseType.title,
            username: elem.userAssignee.username,
            request_date: elem.created_at,
            supervisor_accept: elem.created_at,
            assignment_date: elem.assignmentDate,
            acceptance_date: elem.lawyerAcceptanceDate,
            // enddate: null,
          };
        });
      } else {
        this.dataSource = data.map((elem) => {
          for (let key in elem) {
            const isDate = isIsoDate(elem[key]);
            const isNullish = elem[key] == null;
            if (isNullish) elem[key] = "غير متاح";
            if (isDate) {
              moment.locale("ar");
              elem[key] = moment(new Date(elem[key])).format("LL");
            }
          }
          return { ...elem, supervisor_accept: elem.request_date };
        });
      }
    } catch (err) {
      // console.error(err);
    }

    this.isDataLoading = false;
  }

  async getExportData(data) {
    try {
      if (this.serviceSlug == ServicesSlug.INQUIRY_SERVICES) {
        this._tableService.tableUrl = "admin/inquiry/lawyer-statistical-report";
      } else {
        this._tableService.tableUrl = "admin/lawyer-statistical-report";
      }
      // Prepare the filter with service and limit to get all records
      let exportFilter: any = {
        where: JSON.parse(JSON.stringify(this.filters.where)),
        limit: 100000,
        offset: 0
      };
      // Add service filter for non-inquiry services
      if (this.serviceSlug !== ServicesSlug.INQUIRY_SERVICES) {
        if (
          !exportFilter.where.and ||
          exportFilter.where.and.length === 0 ||
          exportFilter.where.and.every((obj: any) => Object.keys(obj).length === 0)
        ) {
          exportFilter.where.and = [{ service: this.serviceSlug }];
        } else {
          exportFilter.where.and = exportFilter.where.and.filter(
            (obj: any) => !obj.hasOwnProperty("service")
          );
          exportFilter.where.and.unshift({ service: this.serviceSlug });
        }
      } else {
        exportFilter.where.and = exportFilter.where.and.filter(
          (obj: any) => !obj.hasOwnProperty("service")
        );
      }
      let data = await this._tableService
        .getData<any>(exportFilter)
        .toPromise();

      let exportData = data.map((elem, index) => {
        for (let key in elem) {
          const isDate = isIsoDate(elem[key]);
          const isNullish = elem[key] == null;
          if (isNullish) elem[key] = "غير متاح";
          if (isDate) {
            moment.locale("ar");
            elem[key] = moment(new Date(elem[key])).format("LL");
          }
        }
        let processed;
        if (this.serviceSlug === ServicesSlug.INQUIRY_SERVICES) {
          processed = {
            ...elem,
            case_title: elem.caseType?.title || elem.case_title,
            username: elem.userAssignee?.username || elem.username,
            request_date: elem.created_at,
            supervisor_accept: elem.created_at,
            assignment_date: elem.assignmentDate,
            acceptance_date: elem.lawyerAcceptanceDate,
          };
        } else {
          processed = { ...elem, supervisor_accept: elem.request_date };
        }
        return processed;
      });
      await this._dataTableComponent.downloadAllData(exportData);
      
    } catch (err) {
      console.error("Error details:", err);
    }
  }

  getDataForAction(data) {
    this._tableService.SaveItem(data).subscribe(
      (row: any) => {
        this._tableService.redirect(this.url);
      },
      (error) => {
        this._dataService.notification(error.error.error.message);
      }
    );
  }

  async handleRowActions(data: { action: RowActions; row: any }) {
    const { action, row } = data;
    const caseId = row.case_id;

    if (action === RowActions.caseEnding) {
      await this.handleFinishCaseDialog(caseId);
    } else {
      let assigneeType: UserRoles;

      if (action === RowActions.transferToLawyer) {
        assigneeType = UserRoles.lawyer;
        await this.handleAssignCaseDialog(assigneeType, caseId);
      } else if (action === RowActions.transferToReconciliation) {
        assigneeType = UserRoles.conciliator;
        await this.handleAssignCaseDialog(assigneeType, caseId);
      } else if (action === RowActions.transferToSupervisor) {
        assigneeType = UserRoles.supervisor;
        await this.handleAssignCaseDialog(assigneeType, caseId);
      }
    }
  }

  async handleAssignCaseDialog(assigneeType: UserRoles, caseId: Number) {
    const dialogData: null | { assigneeIds: number[] } = await this._dialog
      .open(AssignDialogComponent, {
        direction: this._translate.currentLang == "ar" ? "rtl" : "ltr",
        panelClass: "white-dialog",
        autoFocus: false,
        data: {
          assigneeType,
        },
      })
      .afterClosed()
      .toPromise();

    if (!dialogData) return;
    const { assigneeIds } = dialogData;

    assigneeType === UserRoles.supervisor
      ? await this._http
          .patch(
            `${environment.apiHost}admin/user-cases/${caseId}`,
            {
              supervisor_id: assigneeIds[0],
            },
            {
              headers: getHeadersWithToken(),
            }
          )
          .toPromise()
      : await this._http
          .post(
            `${environment.apiHost}admin/usercase-reassign-assignees`,
            {
              assignee_ids: assigneeIds,
              assignees_type: assigneeType,
              usercase_id: caseId,
            },
            {
              headers: getHeadersWithToken(),
            }
          )
          .toPromise();

    this._tableService.redirect(this.url);
  }

  async handleFinishCaseDialog(caseId: number) {
    const isFinish: boolean = await this._dialog
      .open(ConfirmDialogComponent, {
        direction: this._translate.currentLang == "ar" ? "rtl" : "ltr",
        panelClass: "confirm-dialog",
        data: {
          content: this._translate.instant(
            "confirm-dialog.are-you-want-finish-case"
          ),
          icon: "close",
        },
      })
      .afterClosed()
      .toPromise();

    if (isFinish) {
      try {
        await this._http
          .patch(
            `${environment.apiHost}admin/response-user-cases/${caseId}`,
            {
              status: "FINISH",
            },
            {
              headers: getHeadersWithToken(),
            }
          )
          .toPromise();

        this._tableService.redirect(this.url);
      } catch (err) {
        // console.error(err);
      }
    }
  }

  async handleSearchChange(value: string) {
    // TODO: refactor all this logic, it's just a workaround to manipulate the data table component directly because of the poor API
    this.isDataLoading = true;

    const searchResult = await this._http
      .post<{ count: number; result: any[] }>(
        `${environment.apiHost}admin/usercase-search`,
        {
          keyword: value,
          skip: 0,
        },
        {
          headers: getHeadersWithToken(),
        }
      )
      .toPromise();

    this.dataSource = searchResult.result.map((userCase) => ({
      ...userCase,
      supervisorName: `المشرف: ${userCase.userSupervisor?.username}`,
      caseImage: userCase.caseType.image_url,
    }));

    // TODO: not complete solution because pagination not works
    this._dataTableComponent.tableDataLength = searchResult.count;

    this.isDataLoading = true;
  }

  async filterByDate(value: any) {
    let startDate = moment(value.startDate).add(3, "h").toDate()?.toISOString();
    let endDate = moment(value.endDate).add(3, "h").toDate()?.toISOString();
    this.filters["where"] = {
      and: [{ created_at: { gt: startDate } }, { created_at: { lt: endDate } }],
    };
    this.filters['limit'] = this.currentPageSize; 
    if (this._dataTableComponent.paginatorData) {
      this._dataTableComponent.paginatorData.pageSize = this.currentPageSize;
      this._dataTableComponent.paginatorData.pageIndex = 0;
    }
    // Fetch data and count
    await this.getData(this.filters);
    // Update the total count
    try {
      const countResponse: any = await this._tableService
        .getDataCount({ where: this.filters.where })
        .toPromise();
      this._dataTableComponent.tableDataLength = countResponse.count;
    } catch (error) {
      console.error("Error fetching count:", error);
    }
  }

  async changeActiveTab(serviceSlug: ServicesSlug) {
    this.serviceSlug = serviceSlug;
    this._router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this._router.navigate(["lawyers-reports"], {
        queryParams: { serviceSlug: this.serviceSlug },
      });
    });
  }
}
